'use strict';

/**
 * @ngdoc filter
 * @name 360StoreAngularApp.filter:stProductNameShort
 * @function
 * @description
 * # stProductNameShort
 * Filter in the 360StoreAngularApp.
 */
angular.module('360StoreAngularApp')
	.filter('stProductNameShort', function () {
		return function (input) {
			return !input ? input : input.replaceAll('360Works ', '').replace(/ (FileMaker )?Plugin$/, '');
		};
	});
